import { render, staticRenderFns } from "./Insert.vue?vue&type=template&id=25f96086&scoped=true"
import script from "./Insert.vue?vue&type=script&lang=js"
export * from "./Insert.vue?vue&type=script&lang=js"
import style0 from "./Insert.vue?vue&type=style&index=0&id=25f96086&prod&scoped=true&lang=css"
import style1 from "./Insert.vue?vue&type=style&index=1&id=25f96086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f96086",
  null
  
)

export default component.exports